"use strict";

var _interopRequireDefault = require("C:/Users/sandy/Desktop/EIOSYS/Admin/Alembic-Grow-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.verifyAvatar = exports.rejectAvatar = exports.loginEmployeeAlembic = exports.imageUploadedRMCount = exports.getWeeklyWinners = exports.getTotalRmCount = exports.getTotalEmployeesCount = exports.getEmployeeRoles = exports.getEmployeeProfileVerificationCount = exports.firstLoginCount = exports.exportEmployees = exports.defaultEmployeeData = void 0;
var _request = _interopRequireDefault(require("@/utils/request"));
const defaultEmployeeData = exports.defaultEmployeeData = {
  id: 0,
  enabled: true,
  name: '',
  code: undefined,
  avatar: '',
  employeesRole: {
    id: null,
    name: ''
  },
  employeesRoleId: undefined,
  isProfilePictureVerified: false,
  zmLocation: {
    id: null,
    code: undefined,
    name: ''
  },
  rmLocation: {
    id: null,
    code: undefined,
    name: ''
  },
  amLocation: {
    id: null,
    code: undefined,
    name: ''
  },
  mrLocation: {
    id: null,
    code: undefined,
    name: ''
  },
  division: {
    id: null,
    name: ''
  },
  zone: {
    id: null,
    name: ''
  }
};
const getEmployeeProfileVerificationCount = params => (0, _request.default)({
  url: '/employees/profile-verifications',
  method: 'get',
  params
});
exports.getEmployeeProfileVerificationCount = getEmployeeProfileVerificationCount;
const verifyAvatar = data => (0, _request.default)({
  url: '/employees/verify-avatar',
  method: 'post',
  data
});
exports.verifyAvatar = verifyAvatar;
const rejectAvatar = data => (0, _request.default)({
  url: '/employees/reject-avatar',
  method: 'post',
  data
});
exports.rejectAvatar = rejectAvatar;
const getEmployeeRoles = () => (0, _request.default)({
  url: '/employees-roles',
  method: 'get'
});
exports.getEmployeeRoles = getEmployeeRoles;
const getTotalEmployeesCount = () => (0, _request.default)({
  url: '/employees/employeesCount',
  method: 'get'
});
exports.getTotalEmployeesCount = getTotalEmployeesCount;
const getTotalRmCount = () => (0, _request.default)({
  url: '/employees/rmCount',
  method: 'get'
});
exports.getTotalRmCount = getTotalRmCount;
const imageUploadedRMCount = () => (0, _request.default)({
  url: '/employees/imageUploadedRMCount',
  method: 'get'
});
exports.imageUploadedRMCount = imageUploadedRMCount;
const firstLoginCount = () => (0, _request.default)({
  url: '/employees/firstLoginCount',
  method: 'get'
});
exports.firstLoginCount = firstLoginCount;
const exportEmployees = () => (0, _request.default)({
  url: '/employees/excelDownload',
  method: 'get'
});
exports.exportEmployees = exportEmployees;
const getWeeklyWinners = () => (0, _request.default)({
  url: '/rm-scores-weekly/winnerReport',
  method: 'get'
});
exports.getWeeklyWinners = getWeeklyWinners;
const loginEmployeeAlembic = data => (0, _request.default)({
  url: '/employees/alembic-login',
  method: 'post',
  data
});
exports.loginEmployeeAlembic = loginEmployeeAlembic;